import { FormContainerController } from './formContainerInterface';

export function createFormContainerController(): FormContainerController {
    return {
        useProps(props) {
            return {};
        },
    };
}
